import React, { useEffect, useRef, useState } from 'react'
import './StartProject.scss';
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function StartProject({ ZipCode, setZipCode, ServicesData, setUpdateApp }) {
    const navigate = useNavigate()
    const [Render, setRender] = useState();
    const location = useLocation()
    const [ShowHowisWork, setShowHowisWork] = useState(false);
    const [ShowSearch, setShowSearch] = useState(false);
    const [closMenuAnime, setclosMenuAnime] = useState(false);
    const [SearchQuery, setSearchQuery] = useState("");
    const [ServicesDataNew, setServicesDataNew] = useState([]);
    const [ServicesDataNewSubCategory, setServicesDataNewSubCategory] = useState([]);
    const url = new URL(window.location.href);

    const containerRef = useRef(null);
    // intervalFun()
    const scrollRightHowItWork = (pages, leftOrReight, pixels) => {
        const container = containerRef.current;
        const numvver = pixels
        if (container && leftOrReight == true) {
            const scrollAmount = (container.clientWidth * pages);
            container.scrollLeft = scrollAmount + parseInt(numvver);
        } else if (container && leftOrReight == false) {
            const scrollAmount = (container.clientWidth * pages - container.clientWidth - container.clientWidth);
            container.scrollLeft = scrollAmount + parseInt(numvver);
        }
    };
    useEffect(() => {
        let arrray = []
        for (let index = 0; index < ServicesData.length; index++) {
            for (let index2 = 0; index2 < ServicesData[index].sub_services.length; index2++) {
                // console.log(arrray);
                arrray.push(ServicesData[index].sub_services[index2])
            }
        }
        setServicesDataNew(arrray)
        setServicesDataNewSubCategory(arrray);
    }, []);
    return (
        <div className="StartProject" >
            <Helmet>
                {/* <!-- TITLE --> */}
                <title>Start Your Project | Connect With Verified Home Pros | HandyBy</title>

                {/* <!-- Short title --> */}
                <meta name="title" property="title" content="Start Your Project | HandyBy" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Start Your Project | HandyBy" data-react-helmet="true" />

                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="https://www.handyby.com/og-image.jpg" data-react-helmet="true" />

                {/* <!-- Page URL --> */}
                <meta name="og:url" property="og:url" content="https://www.handyby.com/start-project" data-react-helmet="true" />

                {/* <!-- Description --> */}
                <meta name="description" content="Start Your Home Project Today With HandyBy. Connect With Verified Professionals For Air Duct Cleaning, Roofing, HVAC Services, Chimney Sweep, And More." data-react-helmet="true" />
                <meta name="og:description" property="og:description" content="Start Your Home Project Today With HandyBy. Connect With Verified Professionals For Air Duct Cleaning, Roofing, HVAC Services, Chimney Sweep, And More." data-react-helmet="true" />

                <meta name="og:site_name" property="og:site_name" content="HandyBy" data-react-helmet="true" />

                <meta name="keywords" content="Start A Project, Find Contractors, Home Improvement, Air Duct Cleaning, Roofing Pros, HVAC Repair, Chimney Sweep, Verified Pros, HandyBy Services, Local Home Services, Book Home Services, Home Service Platform, Home Repairs, Install Services, Cleaning Services, Trusted Home Pros" data-react-helmet="true" />
            </Helmet>

            <div className="CategoryNav">
                <div className="CategoryNavShape">
                    <span>
                        <h1>HandyBy /</h1>
                        <h1>Start a Project</h1>
                    </span>
                    <span>
                        <h2 onClick={() => setShowHowisWork(true)} >How HandyBy Work?</h2>
                    </span>
                </div>
            </div>
            <div className="StartProjectHeader" onMouseDown={() => {
                setShowSearch(false)
            }} >
                <h1>Ready to start your next home project?</h1>
                <h2>Choose a category to start creating your project</h2>
            </div>
            <div className="StartProjectSeatch">

                <div className="HomePageTopBannerText" onMouseDown={() => {
                    setShowSearch(false)
                }} >
                    <div className="HomePageTopBannerTextInputMain" >
                        <div on className="HomePageTopBannerTextInput">
                            <div className="HomePageTopBannerTextInputImg">

                                {ShowSearch && SearchQuery.length ?
                                    <img className="HomePageTopBannerTextInputImg_Close" src={require(`../../Images/closeMenu.png`)} onClick={() => {
                                        setRender(a => !a)
                                        setSearchQuery("")
                                    }} />
                                    :
                                    <img src={require(`../../Images/search1.png`)} alt="Chimney Cleaning" />
                                }                            </div>
                            <div className="HomePageTopBannerTextInputInputs">
                                <input type="text" className="InputQuestion" placeholder="Tell us what you need help with"
                                    onClick={() => {
                                        setShowSearch(true)
                                        // window.scrollTo(0, 0)
                                    }}
                                    onChange={(a) => {
                                        setShowSearch(true)
                                        setRender(a => !a)
                                        let newnew = ServicesDataNewSubCategory.filter((a2 => a2.toLowerCase().includes(a.target.value.toLocaleLowerCase())))
                                        setRender(a => !a)
                                        setSearchQuery(a.target.value.toLocaleLowerCase())
                                        setServicesDataNew(newnew)
                                    }} />
                                <input
                                    type="number"
                                    inputMode="numeric"
                                    className="InputZipCode" placeholder="ZIP Code" defaultValue={ZipCode && ZipCode.length ? ZipCode : ""} value={ZipCode && ZipCode.length ? ZipCode : ""} onChange={(a) => {
                                        setRender(a => !a)
                                        setZipCode(a.target.value)
                                        setUpdateApp(a => !a)
                                        setRender(a => !a)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {ShowSearch ?
                    <div className="HomePageTopBannerTextInputSearchResults" >
                        <div className="HomePageTopBannerTextInputSearchResultsList">
                            {

                                ServicesDataNew.length > 0 ?
                                    ServicesDataNew.map((A, Index) =>
                                        <a href={`/request-service?service=${A}`} className="HomePageTopBannerTextInputSearchResultsListBox">
                                            <img className="HomePageTopBannerTextInputSearchResultsListBoxImg" src={require(`../../Images/search.png`)} alt="Chimney Cleaning" />
                                            <a href={`/request-service?service=${A}${ZipCode ? `&zipcode=${ZipCode}` : "noe"}`}>{A}</a>
                                        </a>
                                    )
                                    :
                                    <div className="HomePageTopBannerTextInputSearchResultsListBox">
                                        <img className="HomePageTopBannerTextInputSearchResultsListBoxImg" src={require(`../../Images/search.png`)} />
                                        <a >No results</a>
                                    </div>
                            }

                        </div>

                    </div>
                    : null}
            </div>
            <div className="StartProjectCategories" onMouseDown={() => {
                setShowSearch(false)
            }} >
                <div className="StartProjectCategoriesList">
                    <h1>Most Popular Projects</h1>
                    <div className="StartProjectCategoriesListMore">
                        <a href='/request-service?service=Chimney-Fireplace' className="StartProjectCategoriesListBox">
                            <div className="StartProjectCategoriesListBoxImg">
                                <img src={require(`../../Images/chimney.png`)} />
                            </div>
                            <div className="StartProjectCategoriesListBoxBox">
                                <h2>Chimney Sweep</h2>
                            </div>
                        </a>
                        <a href='/request-service?service=Garage-Door' className="StartProjectCategoriesListBox">
                            <div className="StartProjectCategoriesListBoxImg">
                                <img src={require(`../../Images/garage.png`)} />
                            </div>
                            <div className="StartProjectCategoriesListBoxBox">
                                <h2>Garage Door</h2>
                            </div>
                        </a>
                        <a href='/request-service?service=Locksmith' className="StartProjectCategoriesListBox">
                            <div className="StartProjectCategoriesListBoxImg">
                                <img src={require(`../../Images/locksmith.png`)} />
                            </div>
                            <div className="StartProjectCategoriesListBoxBox">
                                <h2>Locksmith</h2>
                            </div>
                        </a>
                        <a href='/request-service?service=Roofing' className="StartProjectCategoriesListBox">
                            <div className="StartProjectCategoriesListBoxImg">
                                <img src={require(`../../Images/roofing.png`)} />
                            </div>
                            <div className="StartProjectCategoriesListBoxBox">
                                <h2>Roofing</h2>
                            </div>
                        </a>
                    </div>
                    <div className="StartProjectCategoriesListMore">

                        <a href='/request-service?service=Air-Duct' className="StartProjectCategoriesListBox">
                            <div className="StartProjectCategoriesListBoxImg">
                                <img src={require(`../../Images/airduct.png`)} />
                            </div>
                            <div className="StartProjectCategoriesListBoxBox">
                                <h2>Air Duct</h2>
                            </div>
                        </a>
                        <a href='/request-service?service=Dryer-Vent' className="StartProjectCategoriesListBox">
                            <div className="StartProjectCategoriesListBoxImg">
                                <img src={require(`../../Images/dryervent.png`)} />
                            </div>
                            <div className="StartProjectCategoriesListBoxBox">
                                <h2>Dryer Vent</h2>
                            </div>
                        </a>
                        <a href='/request-service?service=HVAC' className="StartProjectCategoriesListBox">
                            <div className="StartProjectCategoriesListBoxImg">
                                <img src={require(`../../Images/hvac.png`)} />
                            </div>
                            <div className="StartProjectCategoriesListBoxBox">
                                <h2>HVAC</h2>
                            </div>
                        </a>
                        <a href='/request-service?service=Insulation' className="StartProjectCategoriesListBox">
                            <div className="StartProjectCategoriesListBoxImg">
                                <img src={require(`../../Images/construction.png`)} />
                            </div>
                            <div className="StartProjectCategoriesListBoxBox">
                                <h2>Insulation</h2>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            {ShowHowisWork ?
                <div className="CategoryHowMatchWork">
                    <div className="CategoryHowMatchWorkBoxDark" onClick={() => {

                        setclosMenuAnime(true)
                        setRender(a => !a)
                        setTimeout(() => {
                            setShowHowisWork(false)
                            setclosMenuAnime(false)

                        }, 300);
                    }}></div>
                    <div className={closMenuAnime ? "CategoryHowMatchWorkMain CategoryHowMatchWorkMainAnime" : "CategoryHowMatchWorkMain"} >
                        <h1>How HandyBy Work?</h1>
                        <img className="CategoryHowMatchWorkMainClose" src={require(`../../Images/closeMenu.png`)} onClick={() => {
                            setclosMenuAnime(true)
                            setRender(a => !a)
                            setTimeout(() => {
                                setShowHowisWork(false)
                                setclosMenuAnime(false)

                            }, 300);
                        }} />
                        <div className="CategoryHowMatchWorkList" ref={containerRef}>
                            <div className="CategoryHowMatchWorkBox">
                                <div className="CategoryHowMatchWorkBoxBox1">
                                    <div className="CategoryHowMatchWorkBoxBox1Back">
                                        <h2>Create a Project</h2>
                                        <h3>Find a qualified pro for the exact service you’re looking for :)</h3>
                                        <h4>Roofing contractor near me |</h4>
                                    </div>
                                </div>
                                <h2>Tell Us What You Need</h2>
                                <h3>Submit a quick project request with the service you’re looking for.</h3>
                                <a onClick={() => scrollRightHowItWork(1, true, "-20px")}>Next</a>

                            </div>
                            <div className="CategoryHowMatchWorkBox">
                                <div className="CategoryHowMatchWorkBoxBox2">
                                    <h4>You have new project</h4>
                                    <img className="" src={require(`../../Images/howitwork2.png`)} />
                                </div>
                                <h2>Get Matched with a HandyBy Pro</h2>
                                <h3>We connect you with a qualified, local contractor who can get it done.</h3>
                                <a onClick={() => scrollRightHowItWork(2, true, "40px")}>Next</a>

                            </div>
                            <div className="CategoryHowMatchWorkBox">
                                <div className="CategoryHowMatchWorkBoxBox3">
                                    <img className="" src={require(`../../Images/contractorProfile.jpeg`)} />
                                    <h4>🚘 &nbsp; A HandyBy Pro Is On The Way...</h4>
                                </div>
                                <h2>Post your task</h2>
                                <h3>Your HandyBy Pro shows up ready to work. Work only starts once you both agree on the price.</h3>
                                <a onClick={() => {
                                    setclosMenuAnime(true)
                                    setRender(a => !a)
                                    setTimeout(() => {
                                        setShowHowisWork(false)
                                        setclosMenuAnime(false)

                                    }, 300);
                                }}>Handy Me Now!</a>

                            </div>
                        </div>
                    </div>

                </div>
                : null}
        </div>
    )
}
